import React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";

interface TabConfig {
  label: string;
  path: string;
  component: React.ComponentType;
}

interface TabsProps {
  tabs: TabConfig[];
  activeRoute: React.ReactNode;
}

const Tabs: React.FC<TabsProps> = ({ tabs = [], activeRoute }: TabsProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (tabs.length === 0) {
    return <></>;
  }

  const activeIndex =
    tabs.findIndex((tab) => tab.path === location.pathname) ?? 0;

  const handleTabChange = (event: { index: number }) => {
    const selectedTab = tabs[event?.index] || tabs[0];
    navigate(selectedTab.path);
  };

  return (
    <>
      <TabView
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
        className="m-0 p-0"
      >
        {tabs?.length > 0 &&
          tabs.map((tab, index) => (
            <TabPanel className="m-0 p-0" key={index} header={tab.label}>
              <Routes>
                {tabs?.map((tab, index) => (
                  <Route
                    key={index}
                    path={tab.path}
                    element={<tab.component />}
                  />
                ))}

                {/* Displayed route and component */}
                {activeRoute}
              </Routes>
            </TabPanel>
          ))}
      </TabView>
    </>
  );
};

export default Tabs;
